import type { Type } from '@angular/core';

// Maps a tool id → its standalone component (lazy-loaded). tool-host renders the
// resolved component via *ngComponentOutlet; ids absent here fall back to the
// "coming soon" stub. This is the plug-in point ported tools register into —
// add one line per tool. `diary` is handled separately (delegates to the live
// daily-checkin component), so it is intentionally not listed here.
export const TOOL_COMPONENTS: Record<string, () => Promise<Type<unknown>>> = {
  breathe: () =>
    import('./breathe/breathe.component').then((m) => m.BreatheToolComponent),
  tracker: () =>
    import('./tracker/tracker.component').then((m) => m.TrackerToolComponent),
  sleep: () =>
    import('./sleep/sleep.component').then((m) => m.SleepToolComponent),
  calm: () =>
    import('./calm/calm.component').then((m) => m.CalmToolComponent),
  water: () =>
    import('./water/water.component').then((m) => m.WaterToolComponent),
  meal: () =>
    import('./meal/meal.component').then((m) => m.MealToolComponent),
  steps: () =>
    import('./steps/steps.component').then((m) => m.StepsToolComponent),
  supps: () =>
    import('./supps/supps.component').then((m) => m.SuppsToolComponent),
  mind: () => import('./mind/mind.component').then((m) => m.MindToolComponent),
  next: () => import('./next/next.component').then((m) => m.NextToolComponent),
  myth: () => import('./myth/myth.component').then((m) => m.MythToolComponent),
  brain: () =>
    import('./brain/brain.component').then((m) => m.BrainToolComponent),
  sleepex: () =>
    import('./sleepex/sleepex.component').then((m) => m.SleepexToolComponent),
  meditate: () =>
    import('./meditate/meditate.component').then((m) => m.MeditateToolComponent),
  voice: () =>
    import('./voice/voice.component').then((m) => m.VoiceToolComponent),
  kegel: () =>
    import('./kegel/kegel.component').then((m) => m.KegelToolComponent),
  ear: () => import('./ear/ear.component').then((m) => m.EarToolComponent),
  bone: () =>
    import('./bone/bone.component').then((m) => m.BoneToolComponent),
  eye: () => import('./eye/eye.component').then((m) => m.EyeToolComponent),
  balance: () =>
    import('./balance/balance.component').then((m) => m.BalanceToolComponent),
};

export function hasToolComponent(id: string): boolean {
  return id in TOOL_COMPONENTS;
}
